import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import { Card, CardBody, Row } from "reactstrap";
import { Btn, H3, H4, Image, P } from "../../../../AbstractElements";
import { ApplyForThisJob, EndLessDesigner, Href, ProductDesignerMainCard, SimilarJobs } from "../../../../Constant";
import { dynamicImage } from "../../../../Service/DynamicImage";
import SimilarjobsCards from "./SimilarjobsCards";
import JobDescription from "./jobDescription";

const MainCard = () => {
  return (
    <>
      <Card>
        <div className="job-search">
          <CardBody>
            <div className="d-flex">
              <Image className="img-40 b-r-0 img-fluid  m-r-20" src={dynamicImage("job-search/1.jpg")} alt="job-search"/>
              <div className="flex-grow-1">
                <H4 className="f-w-700">
                  <Link to={Href}>{ProductDesignerMainCard}</Link>
                  <span className="pull-right">
                    <Btn color="primary">{ApplyForThisJob}</Btn>
                  </span>
                </H4>
                <P>{EndLessDesigner}
                  <Rating className="rating ms-1" fillColor="#feb858" initialValue={Math.random() * 5} size={14}/>
                </P>
              </div>
            </div>
            <JobDescription />
          </CardBody>
        </div>
      </Card>
      <div className="header-faq">
        <H3 className="mb-0 f-w-600">{SimilarJobs}</H3>
      </div>
      <Row>
        <SimilarjobsCards  limit={5} jobClass={'col-xl-6 xl-100 box-col-12'} ribbion={false} col12={true}/> 
      </Row>
    </>
  );
};

export default MainCard;
